import { THttpMethod } from '@/types/FetchService.types';

import { TUserStatus } from '@/features/user/store/user.model';

export const KycLevel = {
  0: 'None',
  1: 'Light',
  2: 'Regular',
  3: 'Strong',
  4: 'Refused',
  5: 'Investigating',
};

export const KycReview = {
  0: 'None',
  1: 'Pending',
  2: 'Validated',
  3: 'Refused',
  4: 'Investigating',
  5: 'Closed',
  6: 'Review_open',
  7: 'Review_pending',
};

export type TUserDocumentsSource = 'CONNECT' | 'BAAS' | 'BOTH';
export type TKycDocumentStatusType = 'PENDING' | 'VALIDATED' | 'REFUSED' | 'CANCELED';
export type TKycDocumentStatus =
  | 'TO_REVIEW'
  | 'REVIEWED'
  | 'REVIEWED_TO_SUBMIT'
  | 'PENDING_VALIDATION'
  | 'VALIDATED'
  | 'REFUSED_CLIENT'
  | 'REFUSED'
  | 'CANCELED';

export const KycConnectDocumentStatus: Record<number, TKycDocumentStatusType> = {
  0: 'PENDING',
  1: 'REFUSED',
  2: 'VALIDATED',
};

export const kycLevelColor: { [key in keyof typeof KycLevel]: 'gray' | 'green' | 'red' } = {
  0: 'gray',
  1: 'green',
  2: 'green',
  3: 'green',
  4: 'red',
  5: 'gray',
};

export const kycReviewColor: { [key in keyof typeof KycReview]: 'gray' | 'orange' | 'green' | 'red' } = {
  0: 'gray',
  1: 'orange',
  2: 'green',
  3: 'red',
  4: 'gray',
  5: 'gray',
  6: 'gray',
  7: 'orange',
};

export type TKycStatus =
  | 'not_required'
  | 'optional'
  | 'to_submit_to_treezor'
  | 'pending_treezor'
  | 'to_review'
  | 'to_check'
  | 'validated'
  | 'refused';

export const kycStatusColor: {
  [key in TKycStatus]: 'gray' | 'blue' | 'orange' | 'purple' | 'green' | 'red' | 'darkOrange';
} = {
  not_required: 'gray',
  optional: 'gray',
  to_submit_to_treezor: 'darkOrange',
  pending_treezor: 'blue',
  to_review: 'orange',
  to_check: 'purple',
  validated: 'green',
  refused: 'red',
};

export interface IKycBaasDocument {
  clientId: number;
  codeStatus: TCodeStatus;
  createdDate: string;
  documentId: number;
  documentStatus: TKycDocumentStatusType;
  documentTag: string;
  documentType: string;
  documentTypeId: number;
  fileName: string;
  modifiedDate: string;
  residenceId: number;
  userFirstname: string;
  userId: number;
  userLastname: string;
}

export interface IKycConnectDocument {
  documentId: string;
  comment?: string;
  createdAt?: string;
  documentType: number;
  metadata?: {
    treezor_document_id: number;
  };
  status: number;
  updatedAt?: string;
  userId: number;
}

export interface IKycDocumentPreview {
  contentType: string;
  duration: number;
  url: string;
}

export type TCodeStatus =
  | 600001
  | 600002
  | 600003
  | 600004
  | 600005
  | 600006
  | 600007
  | 600008
  | 600009
  | 600010
  | 600011
  | 600012
  | 600013
  | 600014
  | 600015
  | 600016
  | 600017;

export interface IKycDocument {
  documentId: string;
  userId: number;
  documentType: number;
  fileName?: string;
  codeStatus?: TCodeStatus;
  createdAt?: string;
  updatedAt?: string;
  isAgent?: boolean;
  comment?: string;
  status?: TKycDocumentStatusType;
  agentComment?: string;
  agentStatus?: TKycDocumentStatusType;
  treezorStatus?: TKycDocumentStatusType;
  metadata?: {
    treezorDocumentId?: number;
    connectDocumentId?: string;
  };
}

export type TComputedKycDocument = IKycDocument & {
  kycStatus?: TKycDocumentStatus;
};

export type TDragDropFile = File & { preview: string };

export interface IPostKycDocument {
  documentTypeId: number;
  file: TDragDropFile;
}

export interface IPostKycDocumentResponse {
  expireIn: number;
  documentId: string;
  form: {
    action: string;
    enctype: string;
    method: THttpMethod;
  };
  formFields: {
    'Content-Type': string;
    Policy: string;
    'X-Amz-Algorithm': string;
    'X-Amz-Credential': string;
    'X-Amz-Date': string;
    'X-Amz-Security-Token': string;
    'X-Amz-Signature': string;
    acl: string;
    key: string;
  };
}

export interface IKycReview {
  date?: string;
  comments: string[];
  review?: TUserStatus;
  level?: string;
}
